<template>
  <div>
    <BigGameCard />
  </div>
</template>
<script>
import BigGameCard from './modal/BigGameCard'
export default {
  name: 'MatchLoopCard',
  components: {
    BigGameCard
  },
  created () {
  },
  destroyed () {},
  mounted () {
    // 初始化
  },
  data () {
    return {
      matchId: this.$route.query.matchId,
      programId: Number(this.$route.query.programId)
    }
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/comm/components/MatchLoopCard.vue